import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * <recently-viewed-products>
 * Lee los IDs de productos vistos (localStorage) y pide esta misma sección al
 * endpoint de búsqueda con q=id:.. OR id:.. para renderizar las tarjetas.
 * Si no hay historial, se elimina a sí misma (no ocupa espacio).
 */
class RecentlyViewedProducts extends HTMLElement {
  async connectedCallback() {
    // Evita ejecutarse dos veces (hidratación / morph)
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    const ids = RecentlyViewed.getProducts();
    if (!ids || ids.length === 0) {
      this.remove();
      return;
    }

    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const base =
      (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';

    const url = new URL(base, window.location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url.toString());
      if (!response.ok) return;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fetchedInner = doc.querySelector('.recently-viewed__inner');
      const inner = this.querySelector('.recently-viewed__inner');

      if (fetchedInner && inner && fetchedInner.innerHTML.trim() !== '') {
        inner.innerHTML = fetchedInner.innerHTML;
        this.hidden = false;
      } else {
        this.remove();
      }
    } catch (error) {
      // Silencioso: si falla la carga, simplemente no mostramos la sección.
      this.remove();
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
